@if (alarm) {
  <div class="alarm-detail-content">
    <section class="alarm-detail-header">
      <div class="detail-header">
        <div class="device">
          <a [routerLink]="['/devices']"
             [queryParams]="{ id: alarm.device_id }">
            {{ getSerialNumber(alarm.device_id) }}
          </a>
        </div>

        <div class="tag-container">
          <p-tag
            [value]="severityLabel"
            [severity]="severityColor" />

          <p-tag
            [value]="statusLabel"
            [severity]="statusColor" />

          <p-tag
            [value]="alarmTypeLabel | translateSafe"
            [severity]="'secondary'" />
        </div>
      </div>

      <div class="message-section">
        {{ alarm.message }}

        <span class="label">
          <b>{{ 'common.fields.created' | translateSafe }}</b>
          <br>
          {{ alarm.created_at ? formatTimeAgoTranslation(this._translateService, alarm.created_at) : '-' }}
        </span>
      </div>
    </section>

    <section class="middle-section">
      <section class="measurement-section">
        <p class="title">{{'common.fields.measurement' | translateSafe}}</p>

        <!--<div>
          <span>Gemessener Wert</span>
          <span>
            {{ alarm.measured_value ?? '-' }}
          </span>
        </div>
        <div>
          <span>Schwellwert</span>
          <span>
            {{ alarm.threshold_value_1 ?? '-' }}
          </span>
        </div>-->
      </section>

      <section class="time-section">
        <span class="title">{{'common.title.timeline' | translateSafe}}</span>

        <p-timeline [value]="timeFrame"
                    class="w-full md:w-80"
                    align="left">
          <ng-template #marker
                       let-event>
            <div class="p-timeline-event-connector"
                 data-p="vertical left"
                 data-pc-section="eventconnector"></div>

            <span class="timelineDot"
                  [style.background-color]="event.iconColor">
            </span>

            <!-- if last element -->
            @if (event === timeFrame[timeFrame.length - 1]) {
              <div class="p-timeline-event-connector"
                   data-p="vertical left"
                   data-pc-section="eventconnector"></div>
            }
          </ng-template>
          <ng-template #opposite
                       let-event
                       style="display: none;">
          </ng-template>
          <ng-template #content
                       let-event>
            <div>
              <span class="label">
                {{ event.title }}
                <br>
                {{ event.time }}
              </span>
            </div>
          </ng-template>
        </p-timeline>

      </section>
    </section>

    <section class="modifiedBy-section">
      <span class="title">{{ 'common.navigation.alarm-history.title' | translateSafe }}</span>

      @if (alarm.acknowledged_at) {
        <div class="alarm-history-item">
          <p>{{ 'common.messages.alarm' | translateSafe }} {{('common.enum.alarm-status.acknowledged' | translateSafe).toLocaleLowerCase()}}</p>
          <p>{{ alarm.acknowledged_comment ?? ('common.messages.no-comments' | translateSafe) }}</p>
          @if (alarm.acknowledged_image) {
            <img [src]="bypassUrl(imagePath + alarm.acknowledged_image)"
                 alt="Bild zum Alarmbestätigen">
          }
          @if (alarm.acknowledged_by) {
            <p>{{ formatTimeAgoTranslation(this._translateService, alarm.acknowledged_at) }} {{'common.messages.by' | translateSafe}} {{ getUsernameFromId(alarm.acknowledged_by) }}</p>
          } @else {
            <p>{{ formatTimeAgoTranslation(this._translateService, alarm.acknowledged_at) }}</p>
          }
        </div>
      }

      @if (alarm.resolved_at) {
        <div class="alarm-history-item">
          <p>{{ 'common.messages.alarm' | translateSafe }} {{('common.enum.alarm-status.resolved' | translateSafe).toLocaleLowerCase()}}</p>
          <p>{{ alarm.resolved_comment ?? ('common.messages.no-comments' | translateSafe) }}</p>
          @if (alarm.resolved_image) {
            <img [src]="bypassUrl(imagePath + alarm.resolved_image)"
                 alt="Bild zum Alarmbestätigen">
          }
          @if (alarm.resolved_by) {
            <p>{{ formatTimeAgo(alarm.resolved_at) }} {{'common.messages.by' | translateSafe}} {{ getUsernameFromId(alarm.resolved_by) }}</p>
          } @else {
            <p>{{ formatTimeAgo(alarm.resolved_at) }}</p>
          }
        </div>
      }

    </section>

    @if (hasStatusAction() && canEdit()) {
      <div class="alarm-detail-actions">
        <app-button-icon
          [label]="loading ? ('common.messages.info.please-wait' | translateSafe) : getStatusActionLabel()"
          [iconName]="getStatusActionIcon()"
          class="iconless"
          [disabled]="loading"
          (click)="onStatusActionClick()" />
      </div>
    }
  </div>


  <app-dialog-base [class.open]="isAlarmStatusUpdateOpen"
                   (outSideClick)="closeAlarmStatusUpdateDialog()"
                   iconLeft="edit_note"
                   [buttonAction]="closeAlarmStatusUpdateDialog"
                   [title]="alarmStatusUpdateDialogTitle">
    <alarm-status-update-dialog [alarm]="alarm"
                                [loading]="alarmStatusLoading"
                                (submitUpdate)="confirmAlarmStatusUpdate($event)"
                                (closeClick)="closeAlarmStatusUpdateDialog()" />
  </app-dialog-base>
}
